// extracted by mini-css-extract-plugin
module.exports = {"feed-card":"feed-card_feed-card__Q2LXg"};